import { Filter } from '../types/Filter';

export const getFilterValuesLength = (filter: Filter): number => {
  const { asyncValue, values } = filter;

  return asyncValue ? asyncValue.length : values.length;
};
